import { AccountFacts, IFactsByProperty, IOnboardCompleteFact } from '.';
import { IState } from '../../../store/reducer';

export const selectPropertyFacts = (state: IState, properties: Array<{ id: number }>, factType?: string): IFactsByProperty => {
	return properties?.reduce((all, current) => {
		const { id } = current;
		const facts = state.data.facts.byPropertyByType[id];
		if (facts) {
			if (factType && facts[factType]) {
				const specific = facts[factType];
				if (typeof all[id] !== 'object')
					all[id] = {};
				all[id][factType] = specific;
				return all;
			}
			if (!factType) {
				all[id] = facts;
				return all;
			}
		}
		return all;
	}, {} as IFactsByProperty);
};

export const onboardingCompleteFact = (state: IState, ownerId: string): IOnboardCompleteFact | null => {
	const accountFacts = state.data.facts.byAccountByType[ownerId];
	if (!accountFacts) return null;

	const onboardCompleteFact = accountFacts[AccountFacts.ONBOARD_COMPLETE];
	return onboardCompleteFact ? onboardCompleteFact : null;
};
